<div>
    <div *ngIf="showLayoverFlag" class="layover">
        <img style="height: 10vh" src="./assets/loader/loader.gif" />
    </div>
</div>